import Vue from 'vue'
import Vuex from 'vuex'
import state from '../_config';
import $ from 'jquery'

import axios from 'axios'
import _ from 'lodash'

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  actions: {
    selectValueType(context, data){
      context.commit('selectValueType', data);
    },
    changeYear(context, year){
      //console.log(context, year);
      context.commit('changeYear', year);
    },
    changeSex(context, sex){

      context.commit('changeSex', sex);
    },
    changeMode(context, new_mode){
      context.commit('changeMode', new_mode);
    },
    modifyLocations(context, arg){
      context.commit('modifyLocations', arg);
    },
    toggleAlljapan(context){
      context.commit('toggleAlljapan');
    },
    load_jsons(context){
      context.dispatch('get_map');
    },
    get_map(context){
      //console.log('getmap');
      const url = './json/japan.geojson';
      axios.get(url)
        .then(res =>{
          //console.log('get json', res);
          context.commit('setMap', res);

          context.dispatch('get_data');
        });

    },
    async get_data(context){
      //console.log( 'get_data', this, context, arguments );
      //console.log( 'get_data');
      const state = context.state;
      const api_domain = state.api_domain;
      let endpoint = state.selected.type.value;
      let request = {};

      if( state.selected.mode === 'linegraph'){
        return;
      }


      // 先に、yearsの一覧を取得する
      const years = await axios.get( api_domain + endpoint, {
        params: {
          get_year: true
        }
      });

      context.commit('setYear', years);

      //折れ線グラフモードでなければ、location未指定
      request.sex = state.selected.sex.value;
      request.year = state.selected.year;
      if(_.isBoolean(state.selected.type.ageStandardized)) {
        request.age_standardized = state.selected.type.ageStandardized ? 1 : 0;
      }

      axios.get( api_domain + endpoint, {
        params: request
      }).then( res => {
        //console.log( 'response: ', res);
        context.commit('updateData', res);
      })
    },
    async get_linegraph_data(context) {
      //console.log('get_linegraph_data', this, context, arguments);
      //console.log( 'get_linegraph_data');
      const state = context.state;
      const api_domain = state.api_domain;
      let endpoint = state.selected.type.value;
      let request = {};

      if( state.selected.mode !== 'linegraph'){
        return;
      }

      // 先に、yearsの一覧を取得する
      const years = await axios.get( api_domain + endpoint, {
        params: {
          get_year: true
        }
      });

      context.commit('setYear', years);

      let current_mode = state.selected.mode;

      //console.log( current_mode )

      if (/^linegraph$/.test(current_mode)) {
        //折れ線グラフモードなら、年度未指定
        request.sex = state.selected.sex.value;
        request.location = state.selected.locations.concat(['Japan']).join(',');
        if(_.isBoolean(state.selected.type.ageStandardized)){
          request.age_standardized = state.selected.type.ageStandardized ? 1 : 0;
        }

        axios.get(api_domain + endpoint, {
          params: request
        }).then(res => {
          //console.log('response: ', res);
          context.commit('updateLinegraphData', [res, context.getters]);
        })
      }
    },

  },
  mutations: {
    selectValueType(state, data){
      state.selected.type = data;
      this.dispatch('get_data');
      this.dispatch('get_linegraph_data');
    },
    changeYear(state, text){
      state.selected.year = text;
      this.dispatch('get_data');
    },
    changeSex(state, sex){
      state.selected.sex = sex;
      this.dispatch('get_data');
      this.dispatch('get_linegraph_data');
    },
    changeMode(state, new_mode){
      let prev_mode = state.selected.mode;

      state.selected.mode = new_mode;
      if( /^linegraph$/.test(new_mode)){
        state.previous_mode = prev_mode;
      }else{
        state.previous_mode = '';
      }
    },
    /**
     * 都道府県（location）を指定のインデックスに記録する。
     * Todo: 都道府県名で記録したくない。存在しない都道府県名が登録できてしまう余地はなくしたい。
     * @param state
     * @param index
     * @param location
     */
    modifyLocations(state, [index, location]){
      let locvalue = location;
      /*
       * もし、都道府県の指定があるなら、そのインデックスの場所に指定の都道府県名を入れる
       * 指定がなければ、そのインデックスの場所の要素を削除する
       */
      if( location ){
        // locationがオブジェクトなら、valueを取り出す
        if( _.isObject( location )){
          locvalue = location.value;
        }

        //指定された都道府県がすでにselected.locations内に存在したら、交換する
        // loc_value: 今選んだ都道府県
        // swap_loc_index: 今選んだやつと同じ都道府県になっている要素のindex値
        // now_location_at_index: 今選んだ都道府県が前に選んでいた都道府県
        let swap_loc_index = state.selected.locations.indexOf(locvalue);
        if( swap_loc_index !== -1 ){
          let now_location_at_index = state.selected.locations[index];
          if( now_location_at_index ){
            state.selected.locations.splice(swap_loc_index, 1, now_location_at_index);
          }else{
            return;
          }
        }


        state.selected.locations.splice(index, 1, locvalue);
      }else{
        state.selected.locations.splice(index, 1);
      }
      this.dispatch('get_linegraph_data');
    },
    toggleAlljapan(state){
      state.selected.alljapan = !state.selected.alljapan;
    },
    setMap(state, res){
      //console.log('setMap', res);
      $.each( res.data.features, function(index, data) {
        data.api_data = {};
      });
      state.map = res.data;

    },
    updateData(state, res){
      //console.log('updateData', res);
      delete res.data.Japan;
      this.commit('setRank', res.data);
      this.commit('mergeData', res.data);
    },
    updateLinegraphData(state, [res, getters]){
      //console.log('updateLinegraphData', res, state.linegraph_data);

      //現状のデータを一旦消す
      state.linegraph_data.splice(0, state.linegraph_data.length);

      /*
       * locationをkeyとした連想配列として返ってくるデータを、
       * store.selected.locations の順番に合わせて、配列化する。
       * その際、既定年度（ store.years ）以外のデータを除外する
       */
      _.forEach( state.selected.locations, function(location){
        let linegraph_data = res.data[location];
        let filtered = _.filter( linegraph_data, (data) => {
          return getters.get_years.indexOf(parseInt(data.year)) >= 0;
        });
        state.linegraph_data.push(filtered);
      });

      /*
       * Japan のデータは、別箇所に保存
       */

      let filtered_japan = _.filter( res.data['Japan'], (data) => {
        return getters.get_years.indexOf(parseInt(data.year)) >= 0;
      });
      state.linegraph_japan_data = filtered_japan;

      // 更新完了を通知するために、timestampを押す
      state.linegraph_update_time = (new Date()).getTime();
      //state.linegraph_data = res.data;
    },
    setRank(state, res){
      let array_for_rank = [];
      $.each(res, function(key, value){
        array_for_rank.push(value[0]);
      });
      //console.log( 'rank', array_for_rank);

      array_for_rank.sort(function(a, b){
        //console.log( 'sort', a, b);
        return b.value - a.value;
      });

      $.each( array_for_rank, function(index, data){
        data.rank = index + 1;
        const rank = index + 1;
        let rankgroup = 0;
        if( rank <= 4){
          rankgroup = 0
        }else if(rank <= 8 ){
          rankgroup = 1;
        }else if(rank <= 12){
          rankgroup = 2;
        }else if(rank <= 16){
          rankgroup = 3;
        }else if(rank <= 21){
          rankgroup = 4;
        }else if(rank <= 26){
          rankgroup = 5;
        }else if(rank <= 31){
          rankgroup = 6;
        }else if(rank <= 35){
          rankgroup = 7;
        }else if(rank <= 39){
          rankgroup = 8;
        }else if(rank <= 43){
          rankgroup = 9;
        }else{
          rankgroup = 10;
        }
        data.rankgroup = rankgroup;

      });

    },
    mergeData(state, res){
      //console.log( 'mergeData', state, res);
      $.each( res, function(key, value){
        //console.log('each', key, value);
        $.each( state.map.features, function(index, data){
          //console.log( 'each in each', data, index);

          let name = data.properties.name;
          if( key === name){
            data.api_data = value[0];
            //console.log(data);
          }
        });
      })
      state.update_time = (new Date()).getTime();

    },
    setYear(state, res){
      // 年一覧が更新されていれば
      const years = res.data.map((year) => {
        return parseInt(year);
      });
      if( !_.isEqual(state.years, years)){
        state.years = years.map((year) => {
          return parseInt(year);
        });

        // 選択されている年が未設定なら最新の年を設定する
        if(_.isEmpty(state.selected.year)){
          state.selected.year = _.last(state.years);
        }else if(state.years.indexOf(state.selected.year) === -1){
          //yearsに更新が入ったが、現在値がそのyears無いにないときは
          //近似値を設定する
          let before;
          for(let i = 0; i < state.years.length; i++){
            const after = state.years[i];
            if( _.isEmpty(before) || !_.inRange(state.selected.year, before, after)){
              before = after;
              continue;
            }
            const before_diff = state.selected.year - before;
            const after_diff = after - state.selected.year;
            return before_diff - after_diff > 0 ? after_diff : before_diff;
          }
        }
      }
    }
  },
  getters: {
    get_location_data(state){
      return (location_name) => {
        //console.log( 'get_location_data returned method:', location_name);
        if( /Japan/.test(location_name) ){
          return state.japan_data;
        }
        if( location_name && state.map.features ){
          let pref = state.map.features.filter(function (data) {
            return data.properties.name === location_name;
          });
          return pref[0];
        }
        return null;

      }
    },
    get_locations(state){
      return _.map( state.map.features, (feature) => {
        let obj = {};
        obj.name = feature.properties.name_local;
        obj.value = feature.properties.name;
        obj.label = feature.properties.name;
        return obj;
      });
    },
    /**
     * 2016年対応の名残
     * // 年一覧を取得する。 state.years でも良いのだが、平均寿命のときだけ最新が2016なので、その対応を行う
     * @param state
     * @param getters
     */
    get_years(state){
      return state.years
    },
    selected_year(state){
      return state.selected.year;
    },
    get_title(state){
      if(/ja/.test(state.lang)){
        return state.title.ja;
      }else{
        return state.title.en;
      }
    }
  }

})